"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getComponentDisplayName(Component, defaultName = 'Component') {
    return Component.displayName || Component.name || defaultName;
}
exports.default = getComponentDisplayName;
//# sourceMappingURL=getComponentDisplayName.js.map